import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { ElectronApi } from 'APP/packages/electron/ElectronApi';

export function useElectronIPCPairerPresenter(): void {
  const navigate = useNavigate();

  useEffect(() => {
    ElectronApi.handleDesktopDeepLink(navigate);
  }, []);
}
